module.exports = __webpack_public_path__ + "img/boho-style-7314646_1280.597bbf5e.png";